<div class="d-flex justify-content-end pb-3">
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class=" px-5 py-1" mat-dialog-content>
  <div class="row">
    <div class="col-12 col-lg-3">From</div>
    <div class="col-12 col-lg-9">No Reply - noreply@cryptograph.finance</div>
  </div>
  <div class="row mt-4">
    <div class="col-12 col-lg-3">To</div>
    <div class="col-12 col-lg-9">{{dialogData.target}}</div>
  </div>

  <div class="row mt-4">
    <div class="col-12 col-lg-3">Subject</div>
    <div class="col-12 col-lg-9">
      <input type="text" class="subject-value" [(ngModel)]="subject" disabled>
      <!--<input type="text" class="subject-value" [disabled]="!isEditMode"  [class.i-disabled]="!isEditMode" [(ngModel)]="subject">-->
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12 col-lg-3">
      <label>Body</label>
    </div>
    <div class="col-12 col-lg-9 template-preview" #previewZone>
      <!--<div class="" [innerHTML]="dialogData.content"></div>-->
      <textarea
        name="areaAll"
        [value]="dialogData.content"
        id="areaAll"
        class="w-100"
      ></textarea>
      <div id="fill-content" class="d-none"></div>
    </div>
  </div>
  <!--<div class="row mt-4" [hidden]="isEditMode">
    <div class="col-12 col-lg-3">
      <label for="areaAll">Body</label>
    </div>
    <div class="col-12 col-lg-9">
      <div [innerHTML]="dialogData.content"></div>

    </div>
  </div>-->
</div>

<div class="d-flex px-4 justify-content-end" mat-dialog-actions>
  <!--<button matRipple class="btn my-3 btn-main" (click)="resetTemplate()">Reset default</button>
  <button matRipple class="btn my-3 btn-main ms-3" (click)="apply()">Use my edited Version</button>-->
  <!--<button matRipple class="btn my-3 btn-main ms-3" (click)="apply()">Save</button>-->

</div>
